import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Header.css";
import { FaLinkedin } from "react-icons/fa";
//import MBRLogo from "../assets/png/MBRLogo.png";
import MBRLogo from "../assets/png/MBR Logo.png"


function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      {/* Logo */}
      <div className="logo-container">
        {/* <img src="" alt="" /> */}
        <img src={MBRLogo} alt="MBR Networks Logo" className="logo-image" />
        <h1 className="logo">
          <span className="mbr">MBR</span>
          <br />
          <span className="networks">Networks</span>
        </h1>

        {/* Hamburger Icon (Visible on Mobile) */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>

      {/* Navigation Links */}
      <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
        <li>
          <Link to="/" onClick={() => setMenuOpen(false)}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/about" onClick={() => setMenuOpen(false)}>
            About
          </Link>
        </li>
        <li>
          <Link to="/services" onClick={() => setMenuOpen(false)}>
            Services
          </Link>
        </li>
        <li>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Join Button */}
      <div className="join-btn-container">
        <a
          href="https://www.linkedin.com/company/mbr-networks" // Replace with your actual company page
          target="_blank"
          className="h_join-btn"
        >
          <FaLinkedin className="linkedin-icon" />
          Join with Me
        </a>
      </div>
    </header>
  );
}

export default Header;
